import React from "react";


export const EmptyScreen = () => {
    console.log(`report`);
    return (
        <></>
    )
}